import { render, staticRenderFns } from "./TabNav.vue?vue&type=template&id=fc597cd8&scoped=true"
import script from "./TabNav.vue?vue&type=script&lang=js"
export * from "./TabNav.vue?vue&type=script&lang=js"
import style0 from "./TabNav.vue?vue&type=style&index=0&id=fc597cd8&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../../../../hotel-wc-product/hotel-wc/sources/client/hotel-wc-admin/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "fc597cd8",
  null
  
)

export default component.exports